// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mg2G","field":"styles_field__f5Swy","fieldCol":"styles_fieldCol__2GtZx","diffCol":"styles_diffCol__DHO1i","diff":"styles_diff__2Czzx"};